import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './Navbar.module.css';
import { Menu, X } from 'lucide-react';
import Logo from './Logo';

export default function Navbar({ darkMode }) {
  const { t, i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const navItems = [
    { id: 'home', label: t('nav.home') || 'Home' },
    { id: 'services', label: t('nav.services') || 'Services' },
    { id: 'areas', label: t('nav.areas') || 'Areas' },
    { id: 'why', label: t('nav.why') || 'Why Us' },
    { id: 'feedback', label: t('nav.feedback') || 'Feedback' },
    { id: 'faq', label: t('nav.faq') || 'FAQ' },
    { id: 'team', label: t('nav.team') || 'Team' },
    { id: 'contact', label: t('nav.contact') || 'Contact' }
  ];

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsOpen(false);
    }
  };

  const navAriaLabel = i18n.language === 'ar' ? 'التنقل الرئيسي' : 'Primary navigation';

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      {/* Desktop Navbar */}
      <nav
        className={`${styles.nav} ${darkMode ? styles.dark : styles.light} ${styles.desktop}`}
        aria-label={navAriaLabel}
      >
        <a
          href="#home"
          onClick={(event) => {
            event.preventDefault();
            scrollToSection('home');
          }}
          className={styles.logoBtn}
          aria-label="سطحة هيدروليك الخبر"
        >
          <Logo size={38} variant="icon" />
        </a>
        {navItems.map((item) => (
          <a
            key={item.id}
            href={`#${item.id}`}
            onClick={(event) => {
              event.preventDefault();
              scrollToSection(item.id);
            }}
            className={styles.navBtn}
          >
            {item.label}
          </a>
        ))}
      </nav>

      {/* Mobile Navbar */}
      <div className={styles.mobileNav}>
        <button
          className={`${styles.hamburger} ${darkMode ? styles.dark : styles.light}`}
          onClick={toggleMenu}
          aria-label="Toggle menu"
        >
          {isOpen ? <X size={24} /> : <Menu size={24} />}
        </button>

        {isOpen && (
          <div className={`${styles.dropdown} ${darkMode ? styles.dark : styles.light}`}>
            <div className={styles.dropdownLogo}>
              <Logo size={35} variant="icon" />
              <span>سطحة الخبر</span>
            </div>
            {navItems.map((item) => (
              <a
                key={item.id}
                href={`#${item.id}`}
                onClick={(event) => {
                  event.preventDefault();
                  scrollToSection(item.id);
                }}
                className={styles.dropdownItem}
              >
                {item.label}
              </a>
            ))}
          </div>
        )}
      </div>

      {isOpen && (
        <div className={styles.overlay} onClick={() => setIsOpen(false)} />
      )}
    </>
  );
}